import React from "react";
import PropTypes from "prop-types";
import cname from "./style.module.scss";

/**
 * SwitchButton:
 *  - Generic Input-Switch Component
 */
export function SwitchButton(props) {
  const onChange = (event) => props.onChange(event.target.checked);

  const statusClass = props.checked ? cname.switchedOn : cname.switchedOff;
  const disabled = props.disabled ? cname.disabled : "";

  const className = `${cname.switch} ${statusClass} ${props.className} ${disabled}`;

  return (
    <div className="switchBtn-container">
      <div className={cname.switchButton}>
        <div
          className={className}
          tabIndex={0}
          role="button"
          onClick={() => props.onChange(!props.checked)}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              props.onChange(!props.checked);
            }
          }}
        >
          <input
            id={props.value}
            type="checkbox"
            name={props.value}
            className={props.name}
            value={props.value}
            onChange={onChange}
            checked={props.checked}
            aria-label={props.ariaLabel}
            disabled={props.disabled}
          />
          <span></span>
        </div>
      </div>
      <label htmlFor={props.value} className={`${props.className} ${disabled}`}>
        {props.label}
      </label>
    </div>
  );
}

SwitchButton.propTypes = {
  /**
   * Boolean to switch on/off
   */
  checked: PropTypes.bool.isRequired,
  /**
   * Value to set on switch input
   */
  value: PropTypes.string,
  /**
   * name to set on switch input
   */
  name: PropTypes.string,
  /**
   * Callback for when switch value changes
   */
  onChange: PropTypes.func,
  /**
   * aria-label (alt text)
   */
  ariaLabel: PropTypes.string,
  /**
   * disabled
   */
  disabled: PropTypes.bool,
};

SwitchButton.defaultProps = {
  className: "",
  checked: false,
  name: "",
  value: "",
  ariaLabel: "",
};
